import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

// 路由组件懒加载
const Login = () => import('@/views/Login/index.vue')
const Layout = () => import('@/components/Layout/index.vue')
const Dashboard = () => import('@/views/Dashboard/index.vue')
const Users = () => import('@/views/Users/index.vue')
const UserDetail = () => import('@/views/Users/Detail.vue')
const Houses = () => import('@/views/Houses/index.vue')
const HouseDetail = () => import('@/views/Houses/Detail.vue')

const Banners = () => import('@/views/Banners/index.vue')
const Configs = () => import('@/views/Configs/index.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false, title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    meta: { requiresAuth: true },
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '仪表板', icon: 'el-icon-s-home' }
      },
      {
        path: 'users',
        name: 'Users',
        component: Users,
        meta: { title: '用户管理', icon: 'el-icon-user' }
      },
      {
        path: 'users/:id(\\d+)',
        name: 'UserDetail',
        component: UserDetail,
        meta: { title: '用户详情', hidden: true }
      },
      {
        path: 'houses',
        name: 'Houses',
        component: Houses,
        meta: { title: '房源管理', icon: 'el-icon-house' }
      },
      {
        path: 'houses/:id(\\d+)',
        name: 'HouseDetail',
        component: HouseDetail,
        meta: { title: '房源详情', hidden: true }
      },

      {
        path: 'banners',
        name: 'Banners',
        component: Banners,
        meta: { title: '轮播图管理', icon: 'el-icon-picture' }
      },
      {
        path: 'configs',
        name: 'Configs',
        component: Configs,
        meta: { title: '系统配置', icon: 'el-icon-setting' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  console.log('[Router Guard] 导航:', {
    from: from.path,
    to: to.path,
    fromName: from.name,
    toName: to.name
  })
  
  const token = store.getters['auth/isAuthenticated']
  
  console.log('[Router Guard] 认证状态:', token)
  
  if (to.meta.requiresAuth && !token) {
    console.log('[Router Guard] 未登录，重定向到登录页')
    next('/login')
  } else if (to.path === '/login' && token) {
    console.log('[Router Guard] 已登录，重定向到仪表盘')
    next('/dashboard')
  } else {
    console.log('[Router Guard] 允许导航')
    next()
  }
})

export default router